import { useEffect, useState } from 'react';
import { makeRESTApiRequest } from '../helpers/api';
import { ENDPOINTS } from '../helpers/constants';

/**
 * The processors new Lien Search orders of the county are assigned to, fetched fresh so a change made in
 * Team Management or Manage Counties applies without reloading the app.
 */
const useCountyDefaultProcessors = (county, isEnabled = true) => {
  const [processors, setProcessors] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const trimmedCounty = county?.trim();
    if (!isEnabled || !trimmedCounty) {
      setProcessors([]);
      setLoading(false);
      return undefined;
    }

    // A slower response for a previous county must not overwrite the current one
    let isStale = false;

    const fetchProcessors = async () => {
      // Drop the previous county's processors right away so they are never shown for this one
      setProcessors([]);
      setLoading(true);
      const { response, error } = await makeRESTApiRequest({
        endpoint: ENDPOINTS.DEFAULT_PROCESSORS_OF_COUNTY(trimmedCounty),
        method: 'GET'
      });
      if (isStale) return;
      setProcessors(!error && Array.isArray(response) ? response : []);
      setLoading(false);
    };

    fetchProcessors();

    return () => {
      isStale = true;
    };
  }, [county, isEnabled]);

  return { processors, loading };
};

export default useCountyDefaultProcessors;
